import {
  Box,
  CircularProgress,
  InputAdornment,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { BaseProps, Field } from "./field";

type Props = BaseProps<string> & {
  loading?: boolean;
  options: ({ label: string; value: string; id?: string } | string)[];
  customStyle?: any;
};

export const Dropdown: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<any>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <Select
        disabled={props.loading || props.disabled}
        displayEmpty
        error={!!props.error}
        name={props.name}
        onChange={onChange}
        style={props.customStyle ? props.customStyle : null}
        renderValue={(value) => (
          <Box
            color={`text.${value && !props.disabled ? "primary" : "disabled"}`}
          >
            {`${props.loading ? "Loading..." : value || "No Selection"}`}
          </Box>
        )}
        required={props.required}
        startAdornment={
          props.loading ? (
            <InputAdornment position="start">
              <CircularProgress size="1rem" />
            </InputAdornment>
          ) : null
        }
        value={props.value}
      >
        {props.options.map((option) => {
          if (typeof option === "string") {
            option = {
              value: option,
              label: option,
            };
          }

          return (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          );
        })}
      </Select>
    </Field>
  );
};
